"use strict";

exports.__esModule = true;
exports.FlightCartClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const FlightCartClient = {
  /**
   * create a new cart
   * @param {string} itineraryId
   * @param {boolean} isV1
   * @return {Promise}
   */
  createCart(itineraryId, isV1) {
    const requestId = 'CREATE_FLIGHT_CART';
    const endPointConstant = isV1 ? _constants.ENDPOINTS.FLIGHTS.CREATE_CART_V1 : _constants.ENDPOINTS.FLIGHTS.CREATE_CART;
    const endPoint = endPointConstant.replace('{itineraryId}', itineraryId);
    const config = {
      headers: {
        'x-pricing-version': 1
      }
    };
    return _http.$http.get(requestId, endPoint, config).then(({
      data
    }) => data);
  },
  /**
   * get cart info
   * @param {string} cartId
   * @param {string} searchParams
   * @return {Promise}
   */
  getCart(cartId, searchParams = '') {
    const requestId = 'GET_FLIGHT_CART_V3';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.FLIGHTS.GET_CART, {
      cartId
    });
    const config = {
      headers: {
        'Cache-Control': 'private, no-cache, no-store, must-revalidate',
        Expires: '-1',
        Pragma: 'no-cache',
        'x-pricing-version': 1
      }
    };
    return _http.$http.get(requestId, endPoint + searchParams, config).then(({
      data
    }) => data);
  },
  /**
   * Sell Flight Seat
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {Array<Object>} payload.traveller
   * @param {Object} payload.contact
   * @param {Array<Object>} payload.ssr - is prohibited to be added in V3 reservation
   * @param {boolean} isV3
   * @returns {Promise}
   */
  sellSeat(payload, isV3) {
    const requestId = 'SEAT_RESERVATION_FLIGHT_CART';
    const endPoint = isV3 ? _constants.ENDPOINTS.FLIGHTS.SEAT_RESERVATION_V3 : _constants.ENDPOINTS.FLIGHTS.SEAT_RESERVATION;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * checkout
   * @description checkout flight cart
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {Array<Object>} payload.traveller
   * @param {string} payload.contact
   * @param {string} payload.payment
   * @param {number} payload.total
   * @param {string} payload.specialRequest
   * @param {string} payload.captcha_token
   * @returns {Promise<Cart>}
   */
  checkout(payload) {
    const requestId = 'CHECKOUT_FLIGHT_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.FLIGHTS.CHECKOUT, {
      cartId: payload.cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem Qitaf
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */
  redeemQitaf(payload) {
    const requestId = 'QITAF_REDEEM_FLIGHT_CART';
    const endPoint = _constants.ENDPOINTS.FLIGHTS.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem Wallet
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */
  redeemWallet(payload) {
    const requestId = 'WALLET_REDEEM_FLIGHT_CART';
    const endPoint = _constants.ENDPOINTS.FLIGHTS.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * apply coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {string} payload.couponCode
   * @param {Object} payload.payment
   * @param {string} payload.payment.method
   * @param {Object} payload.payment.card
   * @param {string} payload.payment.card.number first 6 digits string of card number
   * @param {Object} payload.contact
   * @param {string} payload.contact.firstName
   * @param {string} payload.contact.lastName
   * @param {string} payload.contact.email
   * @param {string} payload.contact.title
   * @param {string} payload.contact.dialCode
   * @param {string} payload.contact.phone
   * @param {Object} payload.contact.specialRequest
   * @param {string} payload.contact.specialRequest.minibar
   * @param {string} payload.contact.specialRequest.smoking
   * @param {Array} payload.contact.specialRequest.bedPreference
   * @param {Array} payload.contact.specialRequest.accessibility
   * @return {Promise<Cart>}
   */
  applyCoupon({
    cartId,
    couponCode,
    ...restPayload
  }) {
    const requestId = 'APPLY_COUPON_FLIGHTS';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.FLIGHTS.APPLY_COUPON, {
      cartId,
      couponCode
    });
    return _http.$http.post(requestId, endPoint, {
      data: restPayload
    }).then(({
      data
    }) => data);
  },
  /**
   * remove coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @return {Promise<Cart>}
   */
  removeCoupon({
    cartId
  }) {
    const requestId = 'REMOVE_COUPON_FLIGHTS';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.FLIGHTS.REMOVE_COUPON, {
      cartId
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * get order
   * @param {Object} payload
   * @param {string} payload.orderId
   * @param {string} payload.orderNumber
   * @return {Promise<Cart>}
   */
  getOrder({
    orderId,
    orderNumber
  }) {
    const requestId = 'GET_FLIGHT_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.FLIGHTS.GET_ORDER, {
      orderId,
      orderNumber
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * update Flight Special Service Requests (SSR)
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {Array<Object>} payload.ssr
   * @param {boolean} isV3
   * @returns {Promise}
   */
  updateSSR(payload, isV3 = false) {
    const requestId = 'SSR_UPDATE_FLIGHT_CART';
    const endPoint = isV3 ? _constants.ENDPOINTS.FLIGHTS.UPDATE_SSR_V3 : _constants.ENDPOINTS.FLIGHTS.UPDATE_SSR;
    return _http.$http.put(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  }
};
exports.FlightCartClient = FlightCartClient;